import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { applyInitialTheme } from '@/shared/theme/ThemeContext'
import '@/styles/fonts.css'
import '@n26/nxd/styles.css'
import '@/styles/globals.css'

const renderApp = () => {
  applyInitialTheme()
  const container = document.getElementById('root')
  if (!container) throw new Error('#root not found')
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
}

// Opt-in: by default the dev server talks to a real Managerium.
if (import.meta.env.DEV && import.meta.env.VITE_USE_MOCKS === 'true') {
  const { worker } = await import('@/mocks/browser')
  await worker.start({ onUnhandledRequest: 'bypass' })
}
renderApp()
